import {Player} from "./player";
import {Monster} from "./monster";

export class Damage {

  constructor(player, setup, monster) {
    this.player = new Player(player, setup);
    this.setup = setup;
    this.monster = new Monster(monster, setup, player);
  }

  maxHit() {
    let max = 0;

    switch (this.player.activeWeaponType()) {
      case 'melee':
        max = 0.5 + this.maxHitEffectiveLevel('strength') * (this.player.equipBonus().melee_strength + 64) / 640;
        break;
      case 'ranged':
        max = 0.5 + this.maxHitEffectiveLevel('ranged') * (this.player.equipBonus().ranged_strength + 64) / 640;
        break;
      case 'magic':
        max = this.maxMagic();
        break;
      default:
        console.log('maxHit switch miss', this.player.activeWeaponType());
        return 0;
    }


    let salveBoost = this.player.salveBoost(this.monster);

    //Salve bonus is taken ove slayer boost
    let slayerMultipler = salveBoost > 1 ? salveBoost : this.player.slayerBoost();
    max = Math.floor(max) * slayerMultipler;

    //Handle damage multipliers
    max = Math.floor(Math.floor(max) * this.weaponDamageMultiplier());

    return this.monster.monsterDamageCap(max);
  }

  /**
   * Returns the max hit taking into account special weapons
   */
  maxHitModifiers() {
    //TODO Add any other modifiers from post damage calculation

    if (this.player.isWeaponEquipped([22325, 22486, 22664]))
      return this.calcScytheMaxHit();

    return Math.floor(this.maxHit())
  }

  /**
   * Returns the max hits in an array based on the weapon
   * This will usually return a single hitsplat but scythe and others will attack multiple times per tick
   */
  maxHits() {
    if (this.player.isWeaponEquipped([22325, 22486, 22664]))
      return this.scytheMaxHits();

    return [this.maxHitModifiers()];
  }

  /**
   * WIP
   * TODO: bolt + chaos gauntlets
   * TODO: god + charge?
   * TODO: magic dart
   */
  maxMagic() {
    let baseMax = this.baseSpellMaxHit();

    let equipBase = (1 + this.player.equipBonus().magic_damage / 100);
    let max = baseMax * equipBase;

    console.log('maxMagic:', [
      baseMax,
      this.player.visibleLevel('magic'),
      equipBase,
      max
    ]);

    if (this.player.isVoidSetEquipped()) {
      max = max * this.player.voidSetDamageBonus();
    }

    if (!this.player.isTridentEquipped()) {
      if (this.setup.equipment.shield.id === 20714 && this.setup.activeSpell.fire_spell) { //Tome
        console.log('maxMagic: tome detected', this.setup.equipment.shield);
        max = Math.floor(max) * 1.5;
      }
    }

    return Math.floor(max)
  }

  baseSpellMaxHit() {
    let baseMax = 0;
    if (this.player.isTridentEquipped())
      baseMax = this.tridentMaxHit();
    else if (this.setup.activeSpell !== null)
      baseMax = this.setup.activeSpell.base_max_hit;
    else
      baseMax = 0;

    return baseMax;
  }


  /**
   * Effective level of current combat style
   * @returns {number}
   */
  effectiveLevel() {
    switch (this.player.activeWeaponType()) {
      case 'melee':
        return this.maxHitEffectiveLevel('strength');
      case 'ranged':
        return this.maxHitEffectiveLevel('ranged'); //This seems to be ok
      case 'magic':
        return this.maxHitEffectiveLevel('magic');
    }
    return 0;
  }

  maxHitEffectiveLevels() {
    return {
      attack: this.maxHitEffectiveLevel('attack'),
      strength: this.maxHitEffectiveLevel('strength'),
      ranged: this.maxHitEffectiveLevel('ranged'),
      magic: this.maxHitEffectiveLevel('magic'),
    }
  }


  maxHitStanceBonus() {
    switch (this.player.activeWeaponType()) {
      case 'melee':
        return this.player.stanceBonus_mellee();
      case 'ranged':
        return this.player.stanceBonus_ranged();
      case 'magic':
        return this.player.stanceBonus_magic();
      default:
        return 0;
    }
  }


  maxHitEffectiveLevel(skill) {
    let boostedLevel = this.player.visibleLevel(skill);

    let prayerBonus = (1 + (this.player.prayerBonuses()[skill] / 100)); //Melee Bonus doesnt need strength
    if (skill === 'ranged') {
      prayerBonus = (1 + (this.player.prayerBonuses()['ranged_strength'] / 100)).toFixed(3);
    }

    let stanceBonus = this.maxHitStanceBonus() + 8;
    let prayerBoosted = Math.floor(boostedLevel * prayerBonus);
    let totalBonus = prayerBoosted + stanceBonus;


    if (this.player.isVoidSetEquipped()) {
      totalBonus = totalBonus * this.player.voidSetDamageBonus();
    }

    console.log('maxHitEffectiveLevel-', {
      skill: skill,
      boostedLevel: boostedLevel,
      prayerBonus: prayerBonus,
      maxHitStanceBonus: stanceBonus,
      prayerBoosted: prayerBoosted,
      voidBonus: this.player.voidSetDamageBonus(),
      totalBonus: totalBonus
    });
    return Math.floor(totalBonus);
  }

  tridentMaxHit() {
    let tridentSeas = [11905, 11907, 11908, 22288, 22290];
    let tridentSwamp = [12899, 12900, 22292, 22294];
    let tridentSang = [22323, 22481];

    if (tridentSeas.includes(this.setup.equipment.weapon.id)) {
      console.log('tridentMax hit: seas');
      return this.calcTridentMaxHit(20, this.player.visibleLevel('magic'));
    }

    if (tridentSwamp.includes(this.setup.equipment.weapon.id)) {
      console.log('tridentMax hit: swamp');
      return this.calcTridentMaxHit(23, this.player.visibleLevel('magic'));
    }

    if (tridentSang.includes(this.setup.equipment.weapon.id)) {
      console.log('sangStaff hit: swamp');
      return this.calcTridentMaxHit(24, this.player.visibleLevel('magic'));
    }

    return 0;
  }

  calcTridentMaxHit(base, level) {
    if (level <= 77)
      return base;
    if (level <= 80)
      return base + 1;
    if (level <= 83)
      return base + 2;
    if (level <= 86)
      return base + 3;
    if (level <= 89)
      return base + 4;
    if (level <= 92)
      return base + 5;
    if (level <= 95)
      return base + 6;
    if (level <= 98)
      return base + 7;
    if (level <= 101)
      return base + 8;
    if (level <= 104)
      return base + 9;
    if (level <= 107)
      return base + 10;
    if (level >= 108)
      return base + 11;
  }

  /**
   * Caculates the max hit of the scythe based on the monster size
   * @returns {number|*}
   */
  calcScytheMaxHit() {
    let hits = this.scytheMaxHits();

    return hits[0] + hits[1] + hits[2]
  }


  /**
   * Returns the hits that the scythe would hit
   * @returns {number[]|number}
   */
  scytheMaxHits() {
    let hits = [];
    hits.push(Math.floor(this.maxHit()));

    if (!this.player.isWeaponEquipped([22325, 22486, 22664])) {
      return hits;
    }

    if (this.monster.getSize() > 1) {
      hits.push(Math.floor(0.5 * hits[0])); //2nd hit hits 50% of base
    }

    if (this.monster.getSize() > 2) {
      hits.push(Math.floor(0.5 * hits[1])); //3rd hit hits 25% of base
    }

    return hits;
  }


  weaponDamageMultiplier() {
    switch (this.player.activeWeaponType()) {
      case 'melee':
        return this.attackMultiplier_attack();
      case 'ranged':
        return this.attackMultiplier_ranged();
      case 'magic':
        return this.attackMultiplier_magic();
    }

    return 1
  }

  specialDamageMultiplier() {
    switch (this.player.activeWeaponType()) {
      case 'melee':
        return this.specialAttackMultiplier_attack();
      case 'ranged':
        return this.specialAttackMultiplier_ranged();
      case 'magic':
        return this.specialAttackMultiplier_magic();
    }

    return 1
  }

  attackMultiplier_attack() {
    let bonus = 1;

    bonus += this.setBonusMultiplier_attack();
    bonus += this.weaponBonusMultiplier_attack();
    bonus += this.armourBonusMultiplier_attack();

    return bonus;
  }

  attackMultiplier_ranged() {
    let bonus = this.weaponBonusMultiplier_ranged();

    bonus += this.setBonusMultiplier_ranged();
    // bonus += this.armourBonusMultiplier_attack(); //TODO move to ranged

    return bonus;
  }

  attackMultiplier_magic() {
    let bonus = this.weaponBonusMultiplier_magic();

    bonus += this.setBonusMultiplier_magic();
    // bonus += this.weaponBonusMultiplier_magic();
    // bonus += this.armourBonusMultiplier_attack(); //TODO move to magic

    return bonus;
  }


  weaponBonusMultiplier_ranged() {
    switch (this.setup.equipment.weapon.id) {
      // Dragon hunter crossbow: 1.10 (vs. dragons, wyverns, Great Olm)
      case 21012:
        if (this.monster.isDragonMonster())
          return 1.30; //25 Jan  2018 update from 10% -> 30%
        break;
      // Twisted bow:  (250 + truncate[(3*magic-14) /100] - truncate[(0.3magic-140)² / 100]) /100
      case 20997:
        //TODO in/out chambers
        let cappedMagicLevel = Math.min(this.monster.getLevel('magic'), 250);

        let p1 = (3 * cappedMagicLevel - 14) / 100;
        let p2 = Math.pow(0.3 * cappedMagicLevel - 140, 2) / 100;

        return Math.min(250, (250 + p1 - p2)) / 100;

      // Craws bow 1.5 in wilderness:
      case 22550:
        if (this.player.inWilderness()) {
          return 1.5;
        }
        break;
    }

    return 1;
  }

  weaponBonusMultiplier_magic() {
    if (this.setup.activeSpellbook === 'standard')
      if (this.setup.equipment.weapon.id === 11998)
        return 1.10;


    // Thammaron's sceptre	2.0 when in wilderness
    if (this.player.inWilderness()) {
      if (this.player.isWeaponEquipped([22552, 22555]))
        return 1.25;
    }

    return 1
  }

  setBonusMultiplier_ranged() {
    //Crystal armour - 3% damage boost and 6% accuracy bonus to the crystal bow.
    if (this.player.isCrystalSetEquipped()) {
      console.debug('crystal armour set equipped');
      let count = this.player.crystalArmourSetCount();
      if (count === 4)
        return 0.15;

      return 0.03 * count;
    }

    return 0
  }

  setBonusMultiplier_magic() {
    return 0
  }

  //Set effects
  setBonusMultiplier_attack() {
    //Obsidian set - 10%
    if (this.player.isObsidianSetEquipped())
      return 0.1;

    // Dharoks 0.1% for every hitpoint lost
    if (this.player.isDharoksEquipped()) {
      return this.player.hitpointsLost() / 100
    }

    return 0;
  }

  weaponBonusMultiplier_attack() {
    switch (this.setup.equipment.weapon.id) {

      // Leaf-bladed battleaxe: 1.175 (vs. kurask, turoth)
      case 20727:
        if (this.monster.monsterNameContains(["turoth", "kurask"])) {
          return 0.175;
        }
        break;

      // Arclight: 1.70 (vs. demons)
      case 19675:
        if (this.monster.isDemonMonster()) {
          return 0.7;
        }
        break;

      // Dragon Hunter Lance 1.20 ( vs dragons)
      case 22978:
        if (this.monster.isDragonMonster()) {
          return 0.2;
        }
        break;

      // Viggora's chainmace 1.5 in wilderness
      case 22545:
        if (this.player.inWilderness())
          return 0.5;
        break;

      // Gadderhammer 1.25 against shades
      case 7668:
        if (this.monster.isShadeMonster())
          return 0.25;
        break;

      // Keris 1.3333 against kalphites
      case 10581:
      case 10582:
      case 10583:
      case 10584:
        if (this.monster.isKalphiteMonster())
          return 1 / 3;
        break;
    }
    return 0;
  }

  armourBonusMultiplier_attack() {
    switch (this.setup.equipment.neck.id) {
      //B Neck if obsidian weapon worn
      case 11128:
        if (this.player.isObsidianWeaponEquipped())
          return 0.2;
        break;

      //Darklight?
      //Dharok?
      //CoX Gaurdian
      //Gadderhammer
      //Keris
    }

    return 0;
  }

}



// WEBPACK FOOTER //
// ./src/js/damage.js